import Model from '@/store/plugins/orm/Model'
import { CashRegister } from './ModelRepository'

import TerminalService from '@/services/TerminalService';
import Device from '@/wrappers/Device';
import HashGen from '@/utilities/HashGen';

export class Terminal extends Model {
    static get entity() {
        return 'terminals';
    }

    static get TYPE_CASH_REGISTER() {
        return 'cashRegister';
    }
    static get TYPE_ORDERING_DEVICE() {
        return 'orderingDevice';
    }
    static get TYPE_KITCHEN_DISPLAY_SYSTEM() {
        return 'kitchenDisplaySystem';
    }

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            key: this.attr(null),
            type: this.attr(null),
            uuid: this.attr(null),
            platform: this.attr(null),
            model: this.attr(null),
            manufacturer: this.attr(null),
            cash_register_id: this.attr(null),
            created_at: this.attr(null),

            cashRegister: this.belongsTo(CashRegister, 'cash_register_id'),
        };
    }

    static async current() {
        const terminalId = await TerminalService.getId()
        return Terminal.find(terminalId)
    }

    isCashRegister() {
        return this.type === Terminal.TYPE_CASH_REGISTER
    }

    isOrderingDevice() {
        return this.type === Terminal.TYPE_ORDERING_DEVICE
    }

    isKitchenDisplaySystem() {
        return this.type === Terminal.TYPE_KITCHEN_DISPLAY_SYSTEM
    }
}

export default Terminal
